
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-9ee1e386\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SaveForm.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SaveForm.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-9ee1e386\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SaveForm.vue"),
  /* scopeId */
  "data-v-9ee1e386",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/components/SaveForm.vue
// module id = 225
// module chunks = 1